import { Link, LinkProps } from 'react-router-dom'

import { buildLocalizedPath } from '../utils/localization'

export interface LocalizedLinkProps extends Omit<LinkProps, 'lang'> {
  lang?: string | null
}

export function LocalizedLink({ lang = null, ...props }: LocalizedLinkProps) {
  return <Link {...props} to={buildLocalizedPath(props.to as string)}></Link>
}

